import { useState } from "react";
import { toast } from "sonner";
import axios from "./axios";

export const useGetGameDetails = () => {
  const [loading, setLoading] = useState(false);
  const [gameDetails, setGameDetails] = useState(null);

  const getGameDetails = async (triviaId) => {
    setLoading(true);
    try {
      const res = await axios.get(`/audiences/trivia/show-trivia/${triviaId}`);

      if (res.status === 200) {
        setLoading(false);
        setGameDetails(res?.data);
        return res.data;
      }
    } catch (err) {
      setLoading(false);
      console.error("Game Details Error:", err);
      if (err?.status !== 403) {
        toast.error(
          err?.response?.data?.message || "Failed to fetch game details"
        );
      }
    }
  };

  return { getGameDetails, gameDetails, setGameDetails, loading, setLoading };
};
